import React, { useState } from 'react';
import { Button, Badge } from 'reactstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCopy } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { revokeApiKey } from '../../services/apiKeyService.js';

const ApiKeyCard = ({ apiKeyGuid, userId, createdDate, quoteToolClient, onRevoke }) => {
    const [revoking, setRevoking] = useState(false);

    const handleRevoke = async () => {
        if (!window.confirm('Are you sure you want to revoke this API key? This action cannot be undone.')) {
            return;
        }

        try {
            setRevoking(true);
            await revokeApiKey({ guid: apiKeyGuid, userId });
            toast.success('API key revoked successfully');
            onRevoke(apiKeyGuid);
        } catch (error) {
            console.error('Error revoking API key:', error);
            toast.error('Failed to revoke API key');
        } finally {
            setRevoking(false);
        }
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(apiKeyGuid);
        toast.success('API key GUID copied to clipboard');
    };

    return (
        <div className="api-key-card-item">
            <div className="api-key-info">
                <div className="api-key-guid">
                    <Badge color="secondary" className="me-2">GUID</Badge>
                    <span className="guid-full">{apiKeyGuid}</span>
                </div>
                {createdDate && (
                    <small className="text-muted d-block mt-1">
                        Created: {moment(createdDate).format('MMMM D, YYYY h:mm A')}
                    </small>
                )}
            </div>
            <div className="api-key-actions">
                <Button
                    size="sm"
                    color="secondary"
                    outline
                    onClick={handleCopy}
                    title="Copy GUID to clipboard"
                >
                    <FontAwesomeIcon icon={faCopy} />
                </Button>
                <Button
                    size="sm"
                    color="danger"
                    outline
                    onClick={handleRevoke}
                    disabled={revoking}
                    title="Revoke API key"
                >
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            </div>
        </div>
    );
};

export default ApiKeyCard;
